import { SessionEntity } from 'sonata-static-storage/lib/entities';
import { getSonataSession } from 'sonata-static-storage/lib/helpers/session.helpers';
import { SessionInterface } from 'sonata-static-storage/lib/schemas/session/session.schema';

import type { StateCreator } from 'zustand';

type SessionStore = {
  session: SessionEntity | null;
  setSession: (currentSession?: SessionInterface) => { msg: 'ok' | 'error' };
  removeSession: () => void;
};

export const sessionStore: StateCreator<SessionStore, [['zustand/devtools', never]], []> = set => ({
  removeSession: () => {
    set({ session: null }, false, 'session/removeSession');
  },
  session: null,
  setSession: (currentSession?: SessionInterface) => {
    const session = currentSession ?? getSonataSession();
    if (session) {
      set({ session: new SessionEntity(session) }, false, 'session/setSession');
      return {
        msg: 'ok'
      };
    }

    return {
      msg: 'error'
    };
  }
});
